import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { useEffect, useState } from 'react';
import { Loader } from '../../../components/loader/Loader';
import { SmartAttachmentForm } from '../../../forms/SmartAttachment/SmartAttachmentForm';
import { SmartAttachmentInputs } from '../../../types/SmartAttachment';

interface Props {
  id: string;
}
/**
 * Component for print view of smart attachment
 */
export const SmartAttachmentPrintPage = ({ id }: Props) => {
  const [data, setData] = useState<SmartAttachmentInputs | null>(null);

  /**
   * Loads smart attachment
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.SMART_ATTACHMENT_ITEM}?id=${id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!data) return <Loader />;
  return (
    <div className="relative text-center w-full">
      <SmartAttachmentForm initialValues={data} isPrint />
    </div>
  );
};
